import Box from '@mui/material/Box';
import React from 'react';

import { iconsList } from '@/icons/MUIIconPicker';
import { DropdownOption } from '@/types/generalTypes';

interface IProps {
  lookup: DropdownOption;
  isSelected: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

const AppLookupChip = ({ lookup, isSelected, disabled = false, onClick }: IProps) => {
  const IconComponent = iconsList.find(q => q.name === lookup.icon)?.icon ?? undefined;
  const color = lookup.textColor || '#0A0A0A';

  return (
    <Box
      onClick={onClick}
      sx={{
        height: '24px',
        bgcolor: lookup.backgroundColor,
        border: '1px solid',
        borderColor: isSelected ? color : 'transparent',
        paddingX: '8px',
        color: color,
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        cursor: onClick && !disabled ? 'pointer' : 'default',
        boxShadow: isSelected ? `0 0 3px 0.2px ${color}` : 'transparent'
      }}
    >
      {IconComponent ? <IconComponent className='h-4' style={{ color: lookup.iconColor || color }} /> : undefined}
      <span className='flex-1 text-xs font-medium'>{lookup.title}</span>
    </Box>
  );
};

export default AppLookupChip;
